import React from "react";
import { useIntl } from "react-intl";
import { PropTypes } from "prop-types";
import styled from "styled-components";

import Div from "@components/Div";
import { default as PRIcon } from "@components/Icon";
import GDPRInformationBox from "@components/privacyPolicies/GDPRInformationBox";
import { Text } from "@components/Text";
import Link from "@components/Link";
import Config from "@src/config";
import { PERSONAL_DATA_POLICY } from "@utils/constant";

const Icon = styled(PRIcon)`
  color: var(--blue-dark);
  background: var(--grey-lightest);
  padding: 6px;
  border-radius: 50%;
`;

const GDPRInformationMessage = ({ isCandidateConsentPage = false }) => {
  const { messages } = useIntl();

  return (
    <GDPRInformationBox mt={3}>
      <Div display="flex" alignItems="center">
        <Div mr={[3, 2]}>
          <Icon name="sign"></Icon>
        </Div>

        <Text pl={[0, "10px"]}>
          {isCandidateConsentPage ? messages.privacy_policies_text: messages.my_acc_privacy_policies_text}{" "}
          <Link
            divDisplay="inline"
            target="_blank"
            label={messages.privacy_policies_link_text}
            href={`${Config.WP_URL}/${PERSONAL_DATA_POLICY}`}
          />
        </Text>
      </Div>
    </GDPRInformationBox>
  );
};

GDPRInformationMessage.propTypes = {
  isCandidateConsentPage: PropTypes.bool,
};

export default GDPRInformationMessage;
